import { Partner } from "Store/partners/partnerInterfaces";

export function getCustomLogo(logoName: string): string {
  const stbAssetsUrl = window.env.STB_ASSETS_URL;
  return `${stbAssetsUrl}/logos/${logoName}.svg`;
}

export function getPartnerLogo(partnerId: Partner): string {
  const stbAssetsUrl = window.env.STB_ASSETS_URL;
  return `${stbAssetsUrl}/logos/${partnerLogoFromPartnerId(partnerId)}.svg`;
}

const partnerLogoFromPartnerId = (partnerId: Partner | undefined): string => {
  switch (partnerId) {
    case Partner.AFAG:
      return "akademikerne-afag-logo";
    case Partner.LEGEFORENINGEN:
      return "akademikerne-legeforeningen-logo";
    case Partner.TANNLEGEFORENINGEN:
      return "akademikerne-tannlegeforeningen-logo";
    case Partner.VETERINARENE:
      return "akademikerne-vetrinaerforeningen-logo";
    case Partner.ECONA:
      return "akademikerne-econa-logo";
    case Partner.NATURVITERNE:
      return "akademikerne-naturviterne-logo";
    case Partner.LEKTORLAGET:
      return "akademikerne-nl-logo";
    case Partner.PSYKOLOGFORENINGEN:
      return "akademikerne-psykologiforeningen-logo";
    case Partner.SAMFUNNSVITERNE:
      return "akademikerne-samfunnsviterne-logo";
    case Partner.SAMFUNNSOKONOMENE:
      return "akademikerne-samfunnsokonomene-logo";
    case Partner.COOP:
      return "coop-logo-rgb";
    case Partner.DANSKE_BANK:
      return "danske-bank-logo";
    case Partner.HUSEIERNE:
      return "huseierne-logo";
    case Partner.STOREBRAND:
    default:
      return "beta/storebrand-logo-desktop";
  }
};
